@if (posicao !== null) {
  <div class="regua_barra">
    <div class="regua_icone">
      <span [style.left]="posicao"></span>
    </div>
  </div>
} @else {
  <span class="text-muted">—</span>
}
